import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@next/core-lib/authorization';

import { TemplateComponent } from './template.component';

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild([
      {
        path: 'template/:id',
        component: TemplateComponent,
        canActivate: [AuthGuard],
      },
    ]),
  ],
})
export class TemplateRoutingModule {}
